import { Component } from "@angular/core";
import { nativeAppUrl } from "../shared/utils/native-app-url.utils";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-email-verification-result",
  templateUrl: "./email-verification-result.component.html",
  styleUrls: ["./email-verification-result.component.css"],
  standalone: false,
})
export class EmailVerificationResultComponent {
  public readonly success: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.success = this.route.snapshot.queryParamMap.get("success") === "true";
  }

  public openMobileApp(): void {
    window.location.href = nativeAppUrl("email-verified");
  }

  public continueInBrowser(): void {
    this.router.navigate(["/"]);
  }
}
